import React, { useEffect } from 'react'
import './Wallet_transaction.css'
import Order_Details_Card from '../../profile/right_side_content/orders_tabs/order_details_card/Order_Details_Card'
import { useDispatch, useSelector } from 'react-redux';
import { getAllWalletHistory } from '../../../features/wallet/walletSlice';
import T_Details_Card from '../../profile/right_side_content/t_details_card/T_Details_Card';
import { formatAmount } from '../../../utils/common';
import { Pagination } from 'react-bootstrap';

const Wallet_transaction = () => {
    const data = [
        {
            order_id: 75843,
            item_no: 1,
            price: 1200,
            date: "13th May | 03:28 pm",
            baseLike: '/delivered-order-details'
        },
        {
            order_id: 75843,
            item_no: 1,
            price: 1200,
            date: "13th May | 03:28 pm",
            baseLike: '/delivered-order-details'
        },
    ];


    const dispatch = useDispatch();
    const walletHistory = useSelector((state) => state.wallet.allWalletHistory);

    useEffect(() => {
        dispatch(getAllWalletHistory());
    }, [dispatch]);

    console.log({ walletHistory });

    return (
        <>
            <section className='Wallet_transaction_sec'>
                <div className='row'>
                    {walletHistory?.data?.map((item) => {

                        const isCredit = item.transaction_type === "credit";

                        return (
                            <div className="col-12" key={item.id}>
                                <T_Details_Card
                                    orderId={item.transaction_id || `TXN-${item.id}`}
                                    date={item.createdAt}
                                    price={formatAmount(item.amount)}
                                    type={isCredit ? "Credit" : "Debit"}
                                    subtext={item.description}
                                    showTrackOrder={false}
                                    baseLike={`/wallet-details/${item.id}`}
                                />
                            </div>
                        );
                    })}

                </div>
            </section>
        </>
    )
}

export default Wallet_transaction